module.exports = __webpack_public_path__ + "static/media/escritorio_viejo.00b72d46.svg";